import { render } from "./NoDataFound.vue?vue&type=template&id=1b6f35c6&scoped=true"
const script = {}

import "./NoDataFound.vue?vue&type=style&index=0&id=1b6f35c6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b6f35c6"]])

export default __exports__